import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-menu-icon',
  templateUrl: './menu-icon.component.html',
  styleUrls: ['./menu-icon.component.scss'],
  host:{
    '[class]' : '_classMap'
  }
})
export class MenuIconComponent implements OnInit {

  _classMap:string;
  @Input('IconType') IconType: string;
  @Input('IconName') IconName: string;

  @Input() 
  set ExtraClass(value:string){
    if(value !== undefined)
    this._classMap =this._classMap +  value;
  }
  
  constructor() {
    this._classMap = "icon-thumbnail "
  }

  ngOnInit() {
  }

}
